function isFile(obj) {
    return typeof File !== 'undefined' && obj instanceof File;
}

function isPlainObject(obj) {
    return obj && typeof obj === 'object' && obj.constructor === Object;
}

function objectToFormData(obj, formData = new FormData(), parentKey = '') {
    Object.entries(obj || {}).forEach(([key, value]) => {
        const fullKey = parentKey ? `${parentKey}.${key}` : key;

        if (value == null) return; // skip null / undefined

        // ---------- Files --------------------------------------------------
        if (isFile(value)) {
            formData.append(fullKey, value);
            return;
        }

        // ---------- Arrays -------------------------------------------------
        if (Array.isArray(value)) {
            // empty array → send one blank field so the server can tell it was present
            if (value.length === 0) {
                formData.append(`${fullKey}[]`, '');
                return;
            }

            value.forEach((item, idx) => {
                const itemIsFile = isFile(item);
                const itemIsObject = isPlainObject(item);

                // Primitive items => tags[]=foo | Repeated keys the server recognises
                if (!itemIsFile && !itemIsObject) {
                    formData.append(`${fullKey}[]`, item);
                    return;
                }

                // Nested object / file => keep indexed notation (e.g. files[0])
                const arrayKey = `${fullKey}[${idx}]`;

                if (itemIsFile) {
                    formData.append(arrayKey, item);
                } else {
                    objectToFormData(item, formData, arrayKey);
                }
            });
            return;
        }

        // ---------- Nested objects ----------------------------------------
        if (isPlainObject(value)) {
            objectToFormData(value, formData, fullKey);
            return;
        }

        // ---------- Primitives --------------------------------------------
        formData.append(fullKey, value);
    });

    return formData;
}

export { objectToFormData };
